/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsroomguestsalltime4Inputs */

const en_statsroomguestsalltime4 = /** @type {(inputs: Statsroomguestsalltime4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All time`)
};

const de_statsroomguestsalltime4 = /** @type {(inputs: Statsroomguestsalltime4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insgesamt`)
};

/**
* | output |
* | --- |
* | "All time" |
*
* @param {Statsroomguestsalltime4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsroomguestsalltime4 = /** @type {((inputs?: Statsroomguestsalltime4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsroomguestsalltime4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsroomguestsalltime4(inputs)
	return de_statsroomguestsalltime4(inputs)
});
export { statsroomguestsalltime4 as "statsRoomGuestsAllTime" }